<template>
    <div>
        <BasicCard v-if="o_loading" v-bind:title="`Caricamento sessione di lavoro`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
            <v-hover><v-chip 
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click.stop="goBack" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip>
            </v-hover>
            <BasicCard class="basic_card pt-0" :title="`${ client.name } - ${ location.name } del ${ getFormattedDate(operation.op_date)}`">
                <template v-slot:action>
                    <span v-if="!isClosed">
                    <v-btn v-can="{obj_type:'operation', action: 'edit'}" color="action" fab small @click.stop="updateRegistry" v-if="!editReg"><v-icon class="ma-2" small>edit</v-icon></v-btn>
                    <span v-else>
                        <v-btn color="action" fab small @click.stop="restoreRegistry"><v-icon class="ma-2" small >cancel</v-icon></v-btn>
                    </span>
                    </span>
                </template>
                <div v-if="editReg">
                    <OperationRegistry
                        ref="opRegistry"
                        :o_data="registry_data"
                        v-on:update_op_registry="updateRegistryValidity"
                    />
                    <div class="d-flex justify-center pb-4">
                        <v-btn :disabled="!registryValid" color="primary" @click.stop="saveRegistry">salva</v-btn>
                        <v-btn color="action" @click.stop="restoreRegistry" class="ml-2">annulla</v-btn>
                    </div>
                </div>
                <div v-else>
                    <RowComponent
                        :label="`Conferma ordine`"
                        :value="operation.name">
                    </RowComponent>
                    <RowComponent
                        :label="`tecnici`"
                        :value="operators">
                    </RowComponent>
                    <RowComponent
                        :label="`numero intervento`"
                        :value="operation.order_nr">
                    </RowComponent>
                    <RowComponent
                        :label="`data ordine`"
                        :value="getFormattedDate(operation.order_date)">
                    </RowComponent>
                    <RowComponent
                        :label="`data intervento`"
                        :value="getFormattedDate(operation.op_date)">
                    </RowComponent>
                    <RowComponent
                        :label="`note`"
                        :value="operation.desc">
                    </RowComponent>
                    <RowComponent
                        v-if="partner"
                        v-bind:value="partner.name">
                        <template v-slot:label>intermediario</template>
                        P.IVA: {{partner.piva}}
                    </RowComponent>
                    <RowComponent
                        v-if="operation.op_type"
                        :label="`tipo report`"
                        :value="op_types[operation.op_type].name">
                    </RowComponent>
                    <RowComponent
                        v-if="isClosed"
                        :label="`stato intervento`"
                        :value="`CHIUSO`">
                    </RowComponent>
                    <div>&nbsp;
                        <AuthorInfo
                            :key="operation.updated"
                            :created="operation.created"
                            :created_by="operation.created_by"
                            :updated="operation.updated"
                            :updated_by="operation.updated_by"/>
                    </div>
                </div>
                
            </BasicCard>
            <BasicCard class="basic_card pt-0" :title="`anagrafica cliente`">
                <template v-slot:action>
                    <v-btn :disabled="isClosed" text @click.stop="editClient" class="white--text"><v-icon class="mr-2">edit</v-icon>modifica</v-btn>
                </template>
                <RowComponent
                    v-bind:value="client.name">
                    <template v-slot:label>cliente<StatusIcon class="small mx-2" :status="getStatus(client)"/></template>
                    P.IVA: {{client.piva}}
                </RowComponent>
                <RowComponent
                    v-bind:value="location.name">
                    <template v-slot:label>
                        sede<StatusIcon class="small mx-2" :status="getStatus(location)"/>
                    </template>
                    {{location.address}} {{ location.addrNum }}<br/>
                    {{location.zip}} {{location.city}} ({{ location.district}})<br/>
                    {{location.country}}
                </RowComponent>
            </BasicCard>
            <BasicCard :title="`Modifica lista strumenti di confronto`" v-if="modifySelection">
                <OpPrimarySelection
                    ref="comparatorsSelection"
                    :client_id="operation.client_id"
                    :show_platform_capacity="true"
                    :selected_instruments="operation.comparator_ids"
                    :lock_inst_reports="true"
                    :operation_id="operation._id"
                    :op_type="operation.op_type"
                    :o_all_instrument="operation.all_instrument"
                    >
                </OpPrimarySelection>
            </BasicCard>
            <BasicCard :title="`Modifica lista strumenti`" v-if="modifySelection">
                <OpInstrumentSelection
                    ref="instrumentsSelection"
                    :client_id="operation.client_id"
                    :location_id="operation.location_id"
                    :show_platform_capacity="true"
                    :selected_departments="operation.department_ids"
                    :selected_instruments="operation.instrument_ids"
                    :lock_inst_reports="true"
                    :operation_id="operation._id"
                    :operation_org_id="operation.org_id"
                    :op_type="operation.op_type"
                    :o_all_instrument="operation.all_instrument"
                    >
                </OpInstrumentSelection>
                <div class="d-flex align-center justify-center">
                    <v-btn class="ma-2" color="primary" @click.stop="updateSelections">aggiorna</v-btn>
                    <v-btn class="ma-2" text @click.stop="cancelUpdateSelections">annulla</v-btn>
                </div>
            </BasicCard>
            <div class="full-width" v-else>
                <div  v-if="!isClosed" class="d-flex align-center justify-center my-4" >
                    <v-btn v-can="{obj_type:'operation', action: 'close'}" class="ma-2" color="primary" @click.stop="openCloseOperationDialog">chiudi intervento</v-btn>
                </div>
                <div v-else class="d-flex align-center justify-center my-4" >
                    <v-btn v-can="{obj_type:'operation', action: 'open'}" class="ma-2" color="primary" @click.stop="openReopenOperationDialog">apri intervento</v-btn>
                </div>
                
                <BasicCard :title="`Strumenti di confronto`">
                    <template v-slot:action>
                        <v-btn :disabled="isClosed" text @click.stop="doUpdateSelections" class="white--text"><v-icon class="mr-2">edit</v-icon>modifica</v-btn>
                    </template>
                    <v-card  class="d-flex flex-column my-2 elevation-1" v-for="instr in comparators" :key="instr._id">
                        <OpInstrumentItem
                            :instrument_id="instr._id"
                            :location="location"
                            :show_platform_capacity="true"
                            :key="instr._id">
                            <div class="d-flex flex-column mt-2">
                                <div v-if="reports && reports[instr._id]">
                                    <ReportItem
                                        v-for="rep in reports[instr._id]" :key="rep.id"
                                        :report_id="rep.id"
                                        v-on:report_removed="removeReport">
                                    </ReportItem>
                                </div>
                                <div v-if="!isClosed" class="d-flex full-width justify-end my-2">
                                    <span v-if="operation.op_type">
                                        <v-btn v-if="allowedOp(instr._id)" color="primary" @click="goToReportEdit(instr._id, operation.op_type, operation.op_date)"><v-icon small class="mr-2">add</v-icon>report</v-btn>
                                    </span>
                                    <span v-else-if="op_inst[instr._id].length>0" class="d-flex flex-row align-center">
                                        <v-autocomplete hide-details dense outlined label="tipo report" :items="op_inst[instr._id]" item-value="id" item-text="name" v-model="instr.cr_type"/>
                                        <v-btn fab small class="ml-2" color="primary" :disabled="!instr.cr_type" @click="goToReportEdit(instr._id, instr.cr_type, operation.op_date)"><v-icon>add</v-icon></v-btn>
                                    </span>
                                    <span v-else class="font-weight-bold">Non hai i permessi per fare report su questo strumento</span>
                                </div>
                            </div>
                        </OpInstrumentItem>
                    </v-card >
                </BasicCard>
                <BasicCard :title="`Strumenti`">
                    <template v-slot:action>
                        <v-btn :disabled="isClosed" text @click.stop="doUpdateSelections" class="white--text"><v-icon class="mr-2">edit</v-icon>modifica</v-btn>
                    </template>
                    <v-card  class="d-flex flex-column my-2 elevation-1" v-for="instr in instruments" :key="instr._id">
                        <OpInstrumentItem
                            :instrument_id="instr._id"
                            :location="location"
                            :show_platform_capacity="true"
                            :key="instr._id">
                            <div class="d-flex flex-column mt-2">
                                <div v-if="reports && reports[instr._id]">
                                    <ReportItem
                                        v-for="rep in reports[instr._id]" :key="rep.id"
                                        :report_id="rep.id"
                                        v-on:report_removed="removeReport">
                                    </ReportItem>
                                </div>
                                <div v-if="!isClosed && currentOperation && canCreateReport && checkReportOwner(instr._id)" class="d-flex full-width justify-end my-2" >
                                    <span v-if="operation.op_type">
                                        <v-btn v-if="allowedOp(instr._id)" color="primary" @click="goToReportEdit(instr._id, operation.op_type, operation.op_date)"><v-icon small class="mr-2">add</v-icon>report</v-btn>
                                    </span>
                                    <span v-else-if="op_inst[instr._id].length>0" class="d-flex flex-row align-center">
                                        <v-autocomplete hide-details dense outlined label="tipo report" :items="op_inst[instr._id]" item-value="id" item-text="name" v-model="instr.cr_type"/>
                                        <v-btn fab small class="ml-2" color="primary" :disabled="!instr.cr_type" @click="goToReportEdit(instr._id, instr.cr_type, operation.op_date)"><v-icon>add</v-icon></v-btn>
                                    </span>
                                    <span v-else class="font-weight-bold">Non hai i permessi per fare report su questo strumento</span>
                                </div>
                            </div>
                        </OpInstrumentItem>
                    </v-card >
                </BasicCard>
            </div>
        </div>
        <ConfirmDialog
            v-bind:data="close_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onCloseConfirm"/>
        <ConfirmDialog
            v-bind:data="open_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onOpenConfirm"/>
    </div>
</template>
<script>
// import _ from 'lodash'
import {i_families, report_type} from "../../utils/common.js"
import {formatDatefromTS, getObjStatus} from "../../utils/commonUtils"
import {searchDesign} from "../../utils/dbUtility"
import BasicCard from "../../components/utils/Basic_card"
import AuthorInfo from "../../components/utils/AuthorInfo"
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import OpInstrumentItem from './OpInstrumentItem'
import RowComponent from '../../components/utils/RowComponent.vue'
import StatusIcon from '../../components/utils/StatusIcon'
import OperationRegistry from './OperationRegistry'
import OpInstrumentSelection from './OpInstrumentSelection'
import OpPrimarySelection from './OpPrimarySelection'
import ReportItem from '../reports/ReportItem'

export default {
    components: {BasicCard, OpInstrumentItem, RowComponent, ConfirmDialog, StatusIcon, OperationRegistry, AuthorInfo, OpInstrumentSelection, OpPrimarySelection, ReportItem},
    props: {
        op_id: {
            type: String,
            required: true
        },
        instr_ids: {
            type: Array,
            required: false,
            default: null
        },
        back: {
            type: String,
            required: false,
            default: '/operations/'
        }
    },
    data(){
        return {
            o_loading: true,
            op_details: false,
            op_types: report_type,
            families: i_families,
            close_confirm: {
                dialog: false,
                message: "Sei sicuro di voler chiudere l'intervento/sessione di lavoro?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "close", val: "chiudi"}
                ]
            },
            open_confirm: {
                dialog: false,
                message: "Sei sicuro di voler aprire l'intervento/sessione di lavoro?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "open", val: "apri"}
                ]
            },
            editReg: false,
            operation: null,
            client: null,
            partner: null,
            location: null,
            instruments: [],
            comparators: [],
            op_inst: {},
            reports: {},
            registry_data: {},
            registryValid: true,
            modifySelection: false,
            currentOperation: false
        }
    },
    computed: {
        
        operators() {
            if (!this.$store.state.users){ 
                return
            }
            let users = ''
            for (let i = 0; i < this.operation.assigned.length; i++) {
                users += this.$store.state.users[this.operation.assigned[i]].name
                if (i < this.operation.assigned.length-1) {
                    users += ', '
                }
            }
            return users
        },
        canCreateReport(){
            if (this.operation){
                if (this.$store.state.user.roles.includes('admin')){
                    return true
                }
                else if(this.operation.assigned.includes(this.$store.state.user._id)){
                    return true
                } else {
                    return false
                }
            }
            return false
        },
        isClosed(){
            return this.operation.status == 'closed'
        }
    },
    async mounted() {
        this.o_loading = true
        this.operation = await this.$store.state.$pouch.get('operations', this.op_id)
        this.restoreRegistry()
        await this.loadClient()
        await this.loadPartner()
        // let canClose = await this.checkClose()
        // console.log("$$ canclose", canClose)
        // if (canClose){
        //     this.operation.status = 'closed'
        //     this.$store.state.$pouch.post('operations', this.operation)
        // }
        if (this.instr_ids) {
            this.operation.instrument_ids = _.concat(this.operation.instrument_ids, this.instrument_ids)
            this.doUpdateSelections()
        }
        await this.loadComparators()
        await this.loadInstruments()
        await this.loadReports()
        this.currentOperation = await this.isCurrentOp()
        this.o_loading = false
    },
    methods: {
        // getOperators() {
        //     let users = ''
        //     for (let i = 0; i < this.operation.assigned.length; i++) {
        //         users += this.$store.state.users[this.operation.assigned[i]].name
        //         if (i < this.operation.assigned.length-1) {
        //             users += ', '
        //         }
        //     }
        //     return users
        // },
        updateRegistryValidity(val) {
            this.registryValid = val
        },
        createOpRegistry(){
            this.registry_data = {
                name: this.operation.name,
                assigned: this.operation.assigned,
                order_nr: this.operation.order_nr,
                order_date: this.operation.order_date,
                op_date: this.operation.op_date,
                note: this.operation.note,
                partner_id: this.operation.partner_id,
                org_id: this.operation.org_id
            }
        },
        restoreRegistry() {
            this.editReg = false
            this.createOpRegistry()
        },
        updateRegistry() {
            this.editReg = true
        },
        doUpdateSelections() {
            this.modifySelection = true
        },
        async updateSelections(){
            try{
                Object.assign(this.operation, this.$refs.instrumentsSelection.getData())
                Object.assign(this.operation, this.$refs.comparatorsSelection.getData())
                await this.saveOperation()
                this.modifySelection = false
                this.loadInstruments()
                this.loadComparators()
            } catch(error) {
                console.log('error', error)
            }
        },
        cancelUpdateSelections(){
            this.modifySelection = false
        },
        async saveRegistry(){
            try{
                if (this.$refs.opRegistry.isValid()) {
                    Object.assign(this.operation, this.$refs.opRegistry.getData())
                    await this.saveOperation()
                    this.loadPartner()
                    this.restoreRegistry()
                } 
            } catch(error) {
                console.log('error', error)
            }
        },
        async saveOperation() {
            this.operation.updated_by = this.$store.state.user._id
            this.operation.updated = (new Date()).getTime()
            let docs_to_save = []
            for (let i_id of this.operation.instrument_ids) {
                let instr = await this.$store.state.$pouch.get('registry', i_id)
                if(!instr.ref_orgs.includes(this.$store.state.user.org_id)){
                    instr.ref_orgs.push(this.$store.state.user.org_id)
                    docs_to_save.push(instr)
                }
            }
            console.log("DOCS TO SAVE", docs_to_save)
            let res = await this.$store.state.$pouch.bulkDocs('registry', docs_to_save)
            console.log("saved new elements to registry", res.docs)
            let opRes = await this.$store.state.$pouch.put('operations', this.operation)
            if (opRes.ok) {
                this.operation._rev = opRes.rev
            }
        },
        async loadClient() {
            this.client = await this.$store.state.$pouch.get("registry", this.operation.client_id)
            this.location = await this.$store.state.$pouch.get("registry", this.operation.location_id)
        },
        async loadPartner() {
            if (this.operation.partner_id) {
                this.partner = await this.$store.state.$pouch.get("registry", this.operation.partner_id)
            } else {
                this.partner = null
            }
        },
        async loadInstruments() {
            // filter by user or roles
            if (!this.operation || !this.operation.instrument_ids ) {
                return
            }
            let res = await this.$store.state.$pouch.find("registry", {
                selector: {
                    doc_type: 'instrument',
                    _id: {'$in': this.operation.instrument_ids}
                }, 
                fields: ['_id', 'manufacturer', 'model', 'serno', 'location_id', 'department_id', 'family', 'platforms', 'metrological_info',
                        'domain', 'qr_code', 'name', 'complete']
            })

            this.instruments = res.docs
            this.instr_types()
        },
        async loadComparators(){
            if (!this.operation || !this.operation.comparator_ids ) {
                return
            }
            let res = await this.$store.state.$pouch.find("registry", {
                selector: {
                    doc_type: "instrument",
                    _id: {'$in': this.operation.comparator_ids}
                },
                fields: ['_id', 'manufacturer', 'model', 'serno', 'location_id', 'department_id', 'family', 'platforms', 'metrological_info',
                        'domain', 'qr_code', 'name', 'complete']
            })
            this.comparators = res.docs
            this.instr_types()
        },
        instr_types() {
            let fams = this.families
            let op_inst =  this.op_inst
            let op_types = this.op_types
            let permission = this.$store.state.user.report_type

            // TODO: REMOVE FAMILIES LENGTH  - =>  ALL
            
            _.forEach(this.instruments, function(o) {
                op_inst[o._id] = _.filter(Object.values(op_types), function(op){
                    return Object.keys(fams[o.family].report).includes(op.id) && permission[op.id].enabled && (permission[op.id].families.length == 0 || permission[op.id].families.includes(o.family))
                })
            });
             _.forEach(this.comparators, function(o) {
                // op_inst[o._id] = _.filter(Object.values(op_types), function(op){
                //     let pippo = Object.keys(fams[o.family].report).includes(op.id) && permission[op.id].enabled && (permission[op.id].families.length == 0 || permission[op.id].families.includes(o.family))
                //     return pippo
                // })
                op_inst[o._id] = []
                let op = op_types['iso_simple']
                let testVar = Object.keys(fams[o.family].report).includes(op.id) && permission[op.id].enabled && (permission[op.id].families.length == 0 || permission[op.id].families.includes(o.family))
                if(testVar){
                    op_inst[o._id].push(op)
                }
            });
            console.log('OP INST', this.op_inst)
        },
        allowedOp(instr_id) {
            let ops = this.op_inst[instr_id]
            return _.find(ops, ['id', this.operation.op_type]) != null
        },
        async loadReports() {
            let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'key', ['operation', this.op_id], false)
            /*
            let res = await this.$store.state.$pouch.find("reports", {
                selector: {
                    doc_type: 'report',
                    operation_id: this.op_id,
                    status: {'$ne': 'deleted'}
                }, 
                fields: ['_id', 'instrument_id', 'status', 'op_type', 'check']
            })*/
            this.reports = _.groupBy(res, 'value.instrument_id')
        },
        /*getColor(verified) {
            let color = 'error'
            if (verified) {
                color = 'success'
            }
            console.log('getColor', color)
            return color
        },*/
        getOpName(op_type){
            return this.op_types.find(function(el){
                return el.id === op_type
            })
        },
        openCloseOperationDialog(){
            //console.log('CLOSE OPERATION')
            this.close_confirm.dialog = true;
        },
        async onCloseConfirm(choice){
            try {
                if(choice == "close"){
                    this.operation.status = 'closed'
                    await this.saveOperation()
                }
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        openReopenOperationDialog(){
            //console.log('CLOSE OPERATION')
            this.open_confirm.dialog = true;
        },
        async onOpenConfirm(choice){
            try {
                if(choice == "open"){
                    this.operation.status = 'working'
                    await this.saveOperation()
                }
                this.closeDialog()
            } catch (error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.close_confirm.dialog = false;
            this.open_confirm.dialog = false;
        },
        async goToReportEdit(instr_id, op_type, op_date) {
            try {
                // console.log('******** GO TO REPORT', this.operation.status)
                if (!this.operation.status || this.operation.status == 'created') {
                    this.operation.status = 'working'
                    await this.saveOperation()
                }
                console.log("$$ op_date", op_date, this.operation.op_date)
                this.$router.push({path: "/reports/edit", query: {"operation_id": this.operation._id, "instrument_id": instr_id, "op_type": op_type, "op_date": op_date, "back": this.$router.history.current.fullPath}}) 
            } catch(error) {
                console.log('error', error)
            }
        },
        goToInstrumentEdit(instr_id){
            //if(!this.disabledForNow){
                this.$router.push({name: "editInstrument", query: {"instrument_id": instr_id, "back": this.$router.history.current.fullPath }})
            //}
        },
        goBack(){
            this.$router.push(this.back);
        },
        editClient(){
            this.$router.push({name: "clientDetails", query: {client_id: this.operation.client_id, back: this.$router.history.current.fullPath} })
        },
        getFormattedDate(ts) {
            return formatDatefromTS(ts)
        },
        getStatus(obj, data) {
            if (!data){
                data = null
            }
            return getObjStatus(this.$store.state.config.threshold, obj, data)
        },
        removeReport(r_id, instr_id) {
            let idx = _.findIndex(this.reports[instr_id], function(r) { 
                return r_id == r.id 
            });
            this.reports[instr_id].splice(idx, 1)
        },
        checkReportOwner(instr_id){
            if (this.$store.state.user.roles.includes('admin')){
                return true
            }
            if(this.reports){
                let rep = this.reports[instr_id]
                if (rep){
                    if(rep.owner_id == this.$store.state.user._id){
                        return true
                    } else {
                        return false
                    }
                }
            }
            return true
        },
        async isCurrentOp(){
            if(this.$store.state.user.roles.includes('admin')){
                return true
            } else {
                let sel = {
                    status: {$in: ['working', 'created']},
                    op_date: {$lt: this.operation.op_date},
                    assigned: {$in: [this.$store.state.user._id]},
                    dismissed: false
                }
                let res = await this.$store.state.$pouch.find('operations', {selector:sel, fields:['_id']})
                if (res.docs.length == 0){
                    return true
                } else {
                    return false
                }
            }
        },
        // async checkClose(){
        //     let sel = {
        //         operation_id: this.operation._id,
        //         status: {$nin: ['new','measuring','deleted']}
        //     }
        //     let res = await this.$store.state.$pouch.find('reports', {selector:sel, fields:['status']})
        //     let instr_set =  new Set(this.operation.instrument_ids)
        //     if (res.docs.length >= instr_set.size){
        //         return true
        //     } else {
        //         return false
        //     }
        // }
    },
}

</script>
<style scoped>

</style>